import React from 'react';
import CustomListInfo from './CustomListInfo';
import SalvPage from '../common/SalvPage';

export const AddCustomList = () => {
  return (
    <SalvPage title={'Add new list'}>
      <CustomListInfo />
    </SalvPage>
  );
};

export default AddCustomList;
